export default __webpack_public_path__ + "static/media/a037-student-1.2feacf60.png";